"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = Loading;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Loading({
  text,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(Wrapper, props, /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
    color: "primary"
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, null, text));
}
const Wrapper = _styledComponents.styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100% - 32px);
  justify-content: center;
  padding: 16px;

  p {
    margin-top: 16px;
  }
`;